<dx-tag-box #weekdayPicker [(ngModel)]="selectedWeekdays" [dataSource]="availableWeekdays" [showSelectionControls]="true" [readOnly]="readonly"
    placeholder="Select weekdays..." (onValueChanged)="onValueChanged($event)">
    <dx-validator>
        <dxi-validation-rule type="custom" [validationCallback]="hasSelectedWeekdays"
            message="Selecting at least one weekday is required"></dxi-validation-rule>
    </dx-validator>
</dx-tag-box>
